
import React, { useState, useEffect } from 'react';
import { Flex, WhiteSpace, InputItem, Picker, List, Button, Switch, Toast } from 'antd-mobile';
import { createForm } from 'rc-form';

import { CustomerFilter } from '../components/CommonFilter';
import { CountryFilter } from '../components/CountryFilter';
import { PurposeFilter } from '../components/PurposeFilter';

import { RecordTypeId, RecordCreateType } from '../utils/const';

import { calculateBillUnit, calculateDiscountWithPrice } from '../utils/common';

import { BatchSetAccountDiscount, GetDefaultPaidConfigList } from '../../../api/order';

import { AddLogRecord } from '../../../api/usms';

function DiscountConfigForm({ accountIdOptions, ChargeType, CompanyId, form, callback,DiscountConfigCallback }) {

  const [formData, setFormData] = useState({
    ChargeType: [ChargeType]
  });
  const [chargeTypeList] = useState([{ label: '实时扣费', value: ChargeType }]);
  const [errors, setErrors] = useState({});

  const [confirmLoading, setConfirmLoading] = useState(false);

  const [ConfigType, setConfigType] = useState(true);
  const [originDiscountList, setOriginDiscountList] = useState([]);

  useEffect(() => {
    const params = {
      ChargeTypes: +ChargeType,
      DomesticFlag: "Foreign"
    }
    setConfirmLoading(true);
    // 与 PC 端的逻辑不一样
    GetDefaultPaidConfigList(params).then((res) => {
      const { Data = [] } = res;
      setOriginDiscountList(Data || []);
      DiscountConfigCallback(Data || []);
      setConfirmLoading(false);
    }).catch(() => {
      setConfirmLoading(false);
    });
  }, []);

  const onFinish = (value) => {
    setConfirmLoading(true);
    const { AccountId, ChargeType, Discount, Purpose, Price, BrevityCode } = value;

    let DiscountCaulcated = +Discount;

    if (ConfigType) {
      const originPrice = originDiscountList.find(item => (item.BrevityCode === BrevityCode[0]) && (item.Purpose === +Purpose[0]));
      if (originPrice) {
        if (!originPrice.Price) {
          Toast.fail('计算折扣出问题啦~: 所选项目的原价为 0，请查证!');
          return;
        }
        DiscountCaulcated = +calculateDiscountWithPrice(Price, calculateBillUnit(originPrice.Price));
      } else {
        Toast.fail('未找到所选客户的定价信息，请查证!');
        return;
      }
    }

    const params = {
      AccountId: AccountId[0],
      ChargeType: ChargeType[0],
      CompanyId,
      Discounts: [
        {
          Purpose: Purpose[0],
          BrevityCode: BrevityCode[0],
          Discount: DiscountCaulcated
        }
      ],
    };

    BatchSetAccountDiscount(params).then((res) => {
      const { RetCode, Data } = res;
      if (RetCode === 0) {
        try {
          AddLogRecord({
            RecordTypeId: RecordTypeId.CustomerBillConfig,
            OperatorTypeId: RecordCreateType,
            RelatedId: CompanyId + '',
            Content: `${'修改客户折扣（移动端）'}：${JSON.stringify(params)}`,
          });
        } catch (err) {
          console.log('err', err);
        }

        if (Data.FailCount > 0 && Data.FailInfo && Data.FailInfo.length) {
          Toast.success(Data.FailInfo[0].ErrorMessage);
        } else {
          Toast.success('设置成功');
          callback();
        }
      }
      setConfirmLoading(false);
    });
  };

  const onConfirm = () => {
    // form.validateFields((error, value) => {
    // });
    const error = {};
    if (!formData.AccountId || !formData.AccountId.length) { error.AccountId = '请选择项目ID' }
    if (!formData.ChargeType || !formData.ChargeType.length) { error.ChargeType = '请选择计费类型' }
    if (!formData.Purpose || !formData.Purpose.length) { error.Purpose = '请选择短信类型' }
    if (!formData.BrevityCode || !formData.BrevityCode.length) { error.BrevityCode = '请选择国家' }
    if (!ConfigType && (!formData.Discount || isNaN(formData.Discount))) { error.Discount = '折扣必须是数字' }
    if (ConfigType && (!formData.Price || isNaN(formData.Price))) { error.Price = '定价必须是数字' }

    setErrors(error);

    if (Object.keys(error).length > 0) {
      return;
    }

    onFinish(formData);
  }

  return (
    <Flex direction='column'>
      <Flex.Item style={{ marginTop: '8px', marginBottom: "4px", width: '100%' }}>
        <Picker
          data={chargeTypeList}
          cols={1}
          value={formData.ChargeType}
          disabled
        // onChange={v => {
        //   setFormData({
        //     ...formData,
        //     ChargeType: v
        //   });
        //   // changeChargeType(v, { ChargeType: v });
        // }}
        >
          <List.Item arrow="horizontal">计费类型</List.Item>
        </Picker>
        <p style={{ color: 'red', paddingLeft: '16px' }}>{errors.ChargeType || null}</p>
      </Flex.Item>
      <Flex.Item style={{ marginTop: '8px', marginBottom: "4px", width: '100%' }}>
        <CustomerFilter options={accountIdOptions || []} value={formData.AccountId} onChange={v => {
          setFormData({
            ...formData,
            AccountId: v
          });
        }} />
        <p style={{ color: 'red', paddingLeft: '16px' }}>{errors.AccountId || null}</p>
      </Flex.Item>
      {/* 保留，万一以后需要选择计费ID，可以直接用 */}
      {/* <Flex.Item style={{ marginTop: '8px', marginBottom: "4px", width: '100%' }}>
        <ProductIdFilter options={discountList} value={formData.ProductId} onChange={v => {
          setFormData({
            ...formData,
            ProductId: v
          });
        }} />
        <p style={{color: 'red', paddingLeft: '16px'}}>{errors.ProductId || null}</p>
      </Flex.Item> */}
      <Flex.Item style={{ marginTop: '8px', marginBottom: "4px", width: '100%' }}>
        <CountryFilter disableAll value={formData.BrevityCode} onChange={v => {
          setFormData({
            ...formData,
            BrevityCode: v
          });
        }} />
        <p style={{ color: 'red', paddingLeft: '16px' }}>{errors.BrevityCode || null}</p>
      </Flex.Item>
      <Flex.Item style={{ marginTop: '8px', marginBottom: "4px", width: '100%' }}>
        <PurposeFilter value={formData.Purpose} onChange={v => {
          setFormData({
            ...formData,
            Purpose: v
          });
        }} />
        <p style={{ color: 'red', paddingLeft: '16px' }}>{errors.Purpose || null}</p>
      </Flex.Item>
      <Flex.Item style={{ marginTop: '8px', marginBottom: "4px", width: '100%' }}>
        <List>
          <List.Item
            extra={<Switch
              checked={ConfigType}
              onChange={value => {
                setConfigType(+value);
              }}
            />}
          >按照定价配置</List.Item>
        </List>
      </Flex.Item>
      {ConfigType ? (
        <Flex.Item style={{ marginTop: '8px', marginBottom: "4px", width: '100%' }}>
          <InputItem
            type="digit"
            placeholder="输入数字"
            onChange={v => {
              setFormData({
                ...formData,
                Price: v
              });
            }}
          >定价</InputItem>
          <p style={{ color: 'red', paddingLeft: '16px' }}>{errors.Price || null}</p>
        </Flex.Item>
      ) : (
        <Flex.Item style={{ marginTop: '8px', marginBottom: "4px", width: '100%' }}>
          <InputItem
            type="digit"
            placeholder="小数折扣，可自动计算 (0.5表示50%)"
            onChange={v => {
              setFormData({
                ...formData,
                Discount: v
              });
            }}
          >折扣</InputItem>
          <p style={{ color: 'red', paddingLeft: '16px' }}>{errors.Discount || null}</p>
        </Flex.Item>
      )}

      <WhiteSpace />
      <WhiteSpace />
      <Button style={{ width: '100%' }} loading={confirmLoading} disabled={confirmLoading} onClick={onConfirm} type="primary">确定</Button><WhiteSpace />
    </Flex>
  )
}

export default createForm()(DiscountConfigForm)